

import {NavLink} from "react-router-dom";

const Index = (props) => {


    return (<div
        className="col-12  min-h-lg-screen d-flex flex-column py-lg-16 px-lg-20 position-relative">
        <div className="card auth-card d-flex align-items-center">
            <div className="card-body">
                <div className="ng-tns-c39-1 ng-star-inserted">
                    <div className="row ng-tns-c39-1">
                        <div
                            className="col-12 col-lg-10 col-md-10 col-xl-10 mx-auto ng-tns-c39-1">
                            <div className="text-center mb-9 ng-tns-c39-1"><NavLink to={'/'}
                                                                                    className="navbar-brand-2 ng-tns-c39-1"><img
                                src={props.logo} alt="logo"
                                className="ng-tns-c39-1"/> </NavLink></div>
                            <div className="text-center mb-8 ng-tns-c39-1"><h1
                                className="h4 ls-tight mt-6 text-muted ng-tns-c39-1">
                                فراموشی رمز عبور  </h1><p
                                className="mt-2 text-muted text-sm opacity-70 ng-tns-c39-1">مارکت
                                رسمی خرید و فروش ارز دیجیتال</p></div>
                            <div className="ng-tns-c39-1 ng-pristine ng-invalid ng-touched">
                                <div className="mb-5 ng-tns-c39-1"><label
                                    htmlFor="emailAddress"
                                    className="form-label ng-tns-c39-1">آدرس ایمیل</label>

                                    <input
                                        type="email" dir="ltr" required=""
                                        maxLength="256" name="emailAddress" id="emailAddress" autoFocus=""
                                        autoComplete="off"
                                        className="form-control en ng-tns-c39-1 ng-pristine ng-invalid "/>

                                </div>


                                <div className="ng-tns-c39-1"><button
                                    type="button"
                                    className="btn btn-primary btn-lg w-full ng-tns-c39-1">
                                   چک کردن ایمیل
                                </button></div>
                            </div>
                            <div className="my-6 text-center ng-tns-c39-1"><small
                                className="ng-tns-c39-1">حساب کاربری ندارید؟</small><NavLink

                                className="text-primary text-sm font-semibold me-2 ng-tns-c39-1"
                                to={window.config.staticAddress + "/auth/register"}>ثبت نام کنید</NavLink></div>
                            <div className="my-6 text-center ng-tns-c39-1"><small
                                className="ng-tns-c39-1">
                                ورود به پنل کاربری
                               </small><NavLink
                                className="text-primary text-sm font-semibold me-2 ng-tns-c39-1"
                                to={window.config.staticAddress + "/auth/login"}>ورود</NavLink>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>)
}
export default Index;